import { z } from 'zod';
import { OperationIdSchema } from '../../ids';
import { CoalitionStateSchema } from '../../models/coalition';
import { API_PREFIX, defineEndpoint } from '../endpoint';

/** The coalition standing against the character's faction, if any (NPC-KINGDOM-REACT, IK-8). */
export const getCoalition = defineEndpoint({
  method: 'GET',
  path: `${API_PREFIX}/me/coalition`,
  access: 'session',
  response: CoalitionStateSchema,
});

/**
 * A negotiated peace (IM-4, IK-6): reparations paid by a board of one of the coalition's powers,
 * from the character's treasury or its company's (by its rank), to the harmed powers' treasuries.
 */
export const makePeace = defineEndpoint({
  method: 'POST',
  path: `${API_PREFIX}/me/peace`,
  access: 'session',
  body: z.object({
    operationId: OperationIdSchema,
    board: z.string().min(1).max(64),
    coins: z.number().int().positive().max(1_000_000),
    from: z.enum(['own', 'company']),
  }),
  response: CoalitionStateSchema,
});
